export default "__VITE_ASSET__Bk7G5MbN__"